/* eslint-disable react-hooks/exhaustive-deps */
import { WithAnalytics } from "@base/utils/hoc/withSendPageAnalytics";
import Button from "@components/atoms/button";
import Header from "@components/molecules/header";
import Layout from "@components/molecules/layout";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { Dialog, Divider } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { useState } from "react";
import { ConnectedProps, connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import { SettingsRow } from "./molecule/row";
import { settingsActions } from "./settings.slice";
import { Content, Link } from "./settings.styled";

import { ReactComponent as Calculator } from "@assets/images/calculator/calculator.svg";
import { ReactComponent as DocumentCheck } from "@assets/images/document/document-check.svg";
import { ReactComponent as ShieldExclamation } from "@assets/images/shield-exclamation/shield-exclamation.svg";
import { ReactComponent as Ticket } from "@assets/images/ticket/ticket.svg";
import { ReactComponent as UserCircle } from "@assets/images/user-circle/user-circle.svg";

type ReduxProps = ConnectedProps<typeof connector>;

const Settings = ({ createStripeCheckoutSession }: ReduxProps) => {
  const navigate = useNavigate();
  const [str, setStr] = useState("");
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleBack = () => {
    navigate("/home");
  };

  const handleSubscription = async () => {
    const res = await createStripeCheckoutSession();
    if (res?.meta.requestStatus === "fulfilled") {
      const newWindow = window.open(res?.payload?.url, "_blank");
      if (newWindow == null || typeof newWindow === "undefined") {
        // The pop-up was blocked
        handleClickOpen();
        setStr(res?.payload?.url);
        return true;
      }
    }
  };

  const handleTermsAndConditions = async () => {
    window.open(
      "https://rkbt.ai/terms-and-conditions",
      "_blank"
    );
  };

  const handleSupport = async () => {
    window.open(
      "https://rkbt-public.s3.eu-west-2.amazonaws.com/terms-and-conditions.html",
      "_blank"
    );
  };

  const handlePrivacyPolicy = async () => {
    window.open(
      "https://rkbt.ai/privacy-policy",
      "_blank"
    );
  };

  const handleSupportClick = () => {
    window.open("mailto:support@rkbt.ai", "_blank");
  };

  return (
    <Layout
      isLayout
      HeaderChildren={<Header title="Settings" handleBack={handleBack} />}
    >
      <Content>
        <SettingsRow
          label="Account"
          icon={<UserCircle />}
          onClick={() => {
            navigate("/settings/account");
          }}
        />
        <Divider />
        <SettingsRow
          label="Subscription"
          icon={<Ticket />}
          onClick={handleSubscription}
        />
        <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <DialogContent dividers>
            <Typography gutterBottom>Open subscription manager</Typography>
          </DialogContent>
          <DialogActions>
            <Button
              textColor={"#FFF"}
              text={"Confirm"}
              type={"button"}
              onClick={() => {
                window.open(str, "_blank");
                handleClose();
              }}
            />
          </DialogActions>
        </Dialog>
        <Divider />
        <SettingsRow
          label="Transactions"
          icon={<Calculator />}
          onClick={() => navigate("/settings/transactions")}
        />
        {/* <SettingsRow
                label="Transactions"
                icon={<Calculator />}
                onClick={() => { }}
            />
            <Divider />
            <SettingsRow
                label="Archive"
                icon={<Archive />}
                onClick={() => { }}
            />
            <Divider />
            <SettingsRow
                label="Help Center"
                icon={<Help />}
                onClick={() => { }}
            /> */}
        <Divider />
        <SettingsRow
          label="Terms Conditions"
          icon={<DocumentCheck />}
          onClick={handleTermsAndConditions}
        />
        <Divider />
        <SettingsRow
          label="Privacy Policy"
          icon={<ShieldExclamation />}
          onClick={handlePrivacyPolicy}
        />
        <Divider />
        <Link href="mailto:support@rkbt.ai" target="_blank">
          <SettingsRow
            label="Support"
            icon={<EmailOutlinedIcon />}
            onClick={() => {}}
          />
        </Link>

        <br />
      </Content>
    </Layout>
  );
};

const mapDispatchToProps = {
  createStripeCheckoutSession: settingsActions.createStripeCheckoutSession,
};

const connector = connect(undefined, mapDispatchToProps);
const SettingsRedux = connector(WithAnalytics(Settings));

export { SettingsRedux as Settings };
